import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';
import { ApiCity, ApiCityProps, ABNTest } from '~/src/api/content/geography/get-all-cities';

export const SET_CITIES_LIST = 'SET_CITIES_LIST';
export const SET_CURRENT_CITY = 'SET_CURRENT_CITY';
export const FETCH_PROVIDER = 'FETCH_PROVIDER';

const initialState: ICityState = {
    currentCity: {
        domain: '',
        name: '',
        cityId: 0,
        phone: '',
        callCenter: '',
        billingHost: '',
        billingDomain: '',
        companyName: '',
        cityIn: '',
        internet: false,
        ctv: false,
        ktv: false,
        telephony: false,
        phoneCode: 0,
        props: {},
        supportPhone: '',
        logo: '',
        region: null,
        abnTests: [],
        hasFreeDeliveryAndInstallation: false,
        plAvailable: 0,
        loyaltyProgramCashback: 0,
    },
    citiesList: [],
    provider: {
        providerId: 0,
        cityId: 0,
        sector: 'b2c',
        operatorId: '',
        timezone: '',
        bssUrl: '',
        active: true,
        regionId: '',
        contacts: {
          phoneCode: '',
          siteUrl: '',
        },
    },
};

export interface ICurrentCity {
    domain: string,
    name: string,
    cityId: number,
    phone: string,
    callCenter: string,
    billingHost: string,
    billingDomain: string,
    companyName: string,
    cityIn: string,
    internet: boolean,
    ctv: boolean,
    ktv: boolean,
    telephony: boolean,
    supportPhone: string,
    phoneCode: number,
    props: ApiCityProps | Record<string, never>,
    logo: string,
    region: number | null,
    abnTests: ABNTest[],
    hasFreeDeliveryAndInstallation: boolean,
    plAvailable: 0 | 1,
    loyaltyProgramCashback: number,
}

export interface IProviderDto {
    providerId: number,
    cityId: number,
    sector: string,
    operatorId: string,
    timezone: string,
    bssUrl: string,
    active: boolean,
    regionId: string | undefined | null,
    contacts: {
        phoneCode: string,
        siteUrl: string,
        phones?: [{
            phoneNumber: string,
            phoneType: string,
        }]
    }
}

export interface ICityState {
    citiesList: ApiCity[],
    currentCity: ICurrentCity,
    provider: IProviderDto,
}

export type TSetCityList = {
    type: typeof SET_CITIES_LIST,
    payload: Partial<Pick<ICityState, 'citiesList'>>,
}

export type TSetCurrentCity = {
    type: typeof SET_CURRENT_CITY,
    payload: Partial<Pick<ICityState, 'currentCity'>>,
}

export type TFetchProvider = {
    type: typeof FETCH_PROVIDER,
    payload: Partial<Pick<ICityState, 'provider'>>,
}

type TCityActions = TSetCityList | TSetCurrentCity | TFetchProvider;

export default (state = initialState, action: TCityActions | THydrateAction): ICityState => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.city
            };
        }

        case SET_CITIES_LIST: {
            return {
                ...state,
                ...action.payload,
            };
        }

        case SET_CURRENT_CITY: {
            return {
                ...state,
                ...action.payload,
            };
        }

        case FETCH_PROVIDER: {
            return {
                ...state,
                ...action.payload,
            };
        }

        default: {
            return state;
        }
    }
};
